import { Component } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GalleryService } from '@services/gallery.service';
import { ConfirmDialogService } from '@utils/confirm-dialog.service';
import { ToastService } from '@utils/toast.service';

@Component({
  selector: 'page-gallery-view',
  templateUrl: './gallery-view.component.html',
  styleUrl: './gallery-view.component.scss'
})
export class GalleryViewPage {
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private galleryService: GalleryService,
    private toast: ToastService,
    private router: Router,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService
  ) { }

  public isLoading = false;
  public isSaving = false;
  public isDeleting = false;

  public titlePage = '';
  public gallery: any = []

  public form = this.formBuilder.group({
    name: [null, [Validators.required]],
    description: [null],
    images: this.formBuilder.array([])
  });

  get name() { return this.form.get('name') }
  set name(value: any) { this.name.setValue(value) }
  get description() { return this.form.get('description') }
  set description(value: any) { this.description.setValue(value) }

  get images(): FormArray { return this.form.controls["images"] as FormArray; }
  getImageAsIndex = (index: number): any => {
    if (typeof this.images.controls[index].get('file')?.value === 'string') {
      return {
        value: this.images.controls[index].get('file')?.value,
        flag: true
      }
    } else {
      return this.images.controls[index].get('file')
    }
  }

  pushImage = () => this.images.push(this.formBuilder.group({ file: [null] }))
  removeImage = (index: number) => {
    this.images.removeAt(index);

    if (this.images.value <= 0) {
      this.pushImage()
    }
  }

  ngOnInit() {
    this.isLoading = true;

    this.activatedRoute.params.subscribe(async routeParams => {
      await this.galleryService.getGallery(routeParams['id'])
        .then((response: any) => this.gallery = response.content)

      if (this.gallery.length === 0) {
        this.router.navigate(['/galleries'])
        this.toast.error('La galería no existe.')
      } else {
        this.titlePage = this.gallery.name;
        this.titleService.setTitle('Viendo la galería: ' + this.titlePage + ' - ' + this.titleService.getTitle());

        this.name = this.gallery.name;
        this.description = this.gallery.description;

        if (this.gallery.images.length > 0) {
          for (const [index, item] of this.gallery.images.entries()) {
            this.images.push(this.formBuilder.group({ file: [item.uri] }))
          }
        } else {
          this.pushImage()
        }

        this.isLoading = false;
      }
    });
  }

  onInputFileChanged = (event: any, index: number) => {
    if (event.target.files && event.target.files.length) {
      this.images.controls[index].get('file')?.setValue(event.target.files[0]);
    }
  }

  update = async () => {
    this.isSaving = true;

    const myFormData = new FormData();

    myFormData.append('name', this.name.value)
    myFormData.append('description', this.description.value)

    for (const [index, item] of this.images.value.entries()) {
      myFormData.append(`image_${index}`, item.file)
    }

    await this.galleryService.update(this.gallery.gallery, myFormData)
      .then(() => this.toast.success('Galería actualizada.'))
      .catch(() => this.toast.error('Error al actualizar la galería.'))

    this.isSaving = false;
  }

  delete = (event: Event) => {
    this.isDeleting = true;

    this.confirmDialogService.dialog('¿Está seguro de eliminar esta galería?', 'Continuar', 'Cancelar')
      .then(() => {
        this.isLoading = true;

        this.galleryService.delete(this.gallery.gallery)
          .then(() => {
            this.toast.success('Galería eliminada exitosamente.')
            this.router.navigate(['/galleries'])
          })
          .catch((error: any) => {
            this.toast.error(error.error.data.message)
            this.isDeleting = false
            this.isLoading = false
          })
      })
      .catch(() => this.isDeleting = false)
  }
}
